




























































































































import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import AppHeader from '@/components/AppHeader.vue';
import {
  HubCard,
  HubHeading,
  HubInput,
  HubButton,
  HubTextarea,
  HubModal,
} from '@/components/HubComponents';
import { registerLog } from '@/services/hub/logsAction';
import jwtDecode from 'jwt-decode';

export default Vue.extend({
  name: 'ViewEvent',
  components: {
    HubCard,
    HubTextarea,
    HubInput,
    HubHeading,
    HubButton,
    HubModal,
    AppHeader,
  },
  props: {
    hash: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      confirmMessage: '',
      modalDelete: false,
      modalActive: false,
      nextStatus: {
        WAITING_LIVE: 'LIVE',
        LIVE: 'ON_DEMAND',
        ON_DEMAND: 'ON_DEMAND',
      },
      menuButtons: [
        {
          icon: 'calendar-month-outline',
          label: this.$t('event'),
          href: `/event/${this.hash}`,
        },
        {
          icon: 'play',
          label: 'Player',
          href: `/player/${this.hash}`,
        },
        {
          icon: 'broadcast',
          label: 'Live Social',
          href: `/live-social/${this.hash}`,
        },
        {
          icon: 'chart-bar',
          label: this.$t('statistics'),
          href: `/statistics/${this.hash}`,
        },
      ],
      username: '',
      id_customer: 0,
      customerPlansId: 0,
      userToken: '',
    };
  },
  computed: {
    ...mapState(['user', 'events']),
    eventState(): 'liveData' | 'odData' {
      return this.event.liveData ? 'liveData' : 'odData';
    },
    event(): Store.Events.Event {
      return this.events.event;
    },
  },
  async mounted() {
    const response = await this.loadEvent({
      planId: this.user.planId,
      hash: this.hash,
    });
    if (response === 'error') {
      this.$router.push({
        name: 'Error',
        params: {
          error: '404',
          title: 'Evento não encontrado!',
          message: 'Volte para a página de eventos e tente novamente.',
        },
      });
    }

    const userInfo = localStorage.getItem('user');
    if (userInfo) {
      const user = JSON.parse(userInfo);

      const { token } = user;
      const decodedToken = jwtDecode(token) as any;
      this.username = decodedToken.sub.nickname;
      this.id_customer = decodedToken.sub.id_customers;
      this.customerPlansId = user.user.plan_id;
      this.userToken = user.token;
    }

    if (!this.events.secret) {
      const loadEvents = {
        planId: this.user.planId,
        actualPage: 0,
        quantity: 1,
        orderBy: 'date',
        orderType: 'ASC',
      };

      await this.loadEvents(loadEvents);
    }
  },
  methods: {
    ...mapActions({
      loadEvent: 'events/loadEvent',
      loadEvents: 'events/loadEvents',
      remove: 'events/remove',
      startOrEndLive: 'events/startOrEndLive',
    }),
    openModal(type: string): void {
      this.modalActive = true;

      if (type === 'exclude') {
        this.modalDelete = true;
        this.confirmMessage = 'delete_event_confirmation';
        return;
      }

      this.confirmMessage = this.event.status === 'WAITING_LIVE'
        ? 'change_status_live_confirmation'
        : 'change_status_od_confirmation';
    },
    async logUserAction(action: string, status: string, description: string) {
      try {
        const logData = {
          id_customers: this.id_customer,
          username: this.username,
          action,
          status,
          description,
        };

        await registerLog(logData);
        console.log('Log registrado com sucesso!');
      } catch (error) {
        console.error('Erro ao registrar o log:', error);
      }
    },
    async excludeEvent(): Promise<void> {
      const actionDescription = `Excluiu o evento ${this.event.title} com Hash: ${this.hash}`;

      try {
        await this.remove([this.event.id]);
        this.$router.push({ name: 'Events' });

        await this.logUserAction('Deletion', 'Success', actionDescription);
      } catch (error) {
        console.error('Erro ao excluir o evento:', error);

        await this.logUserAction('Deletion', 'Error', `Erro ao excluir o evento ${this.event.title} com Hash: ${this.hash}`);
      }
    },
    async changeEventStatus(): Promise<void> {
      const status = this.nextStatus[this.event.status];
      let actionDescription = '';

      let payload = {
        eventId: this.event.id,
        hash: this.hash,
        secret: this.events.secret,
        status,
      } as Services.Events.StartOrEndLive;

      if (status === 'LIVE') {
        payload = {
          ...payload,
          customerPlanId: parseInt(this.user.planId, 10),
        };
        actionDescription = `Iniciou a live do evento ${this.event.title} com Hash: ${this.hash}`;
      } else if (status === 'ON_DEMAND') {
        actionDescription = `Finalizou a live do evento ${this.event.title} com Hash: ${this.hash}`;
      }

      try {
        await this.startOrEndLive(payload);
        Object.assign(this.event[this.eventState], {
          shareLink: 'https://player.jmvstream.com',
        });

        await this.loadEvent({
          planId: this.user.planId,
          hash: this.hash,
        });

        await this.logUserAction('Modification', 'Success', actionDescription);
        console.log('Log registrado com sucesso!');
      } catch (error) {
        console.error('Erro ao mudar o status do evento:', error);

        await this.logUserAction('Modification', 'Error', `Erro ao mudar status para ${status} do evento com Hash: ${this.hash}`);
      } finally {
        this.modalActive = false;
      }
    },
  },
});
